import React from "react"
import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import {para} from "@irati/ui/src/Labels/css/labels"

const StyledTr = styled.tr`
    ${para};
    ${({disabled}) => disabled && `
      color: ${greys.medium};
      font-weight: 200;
    `}
`

const Tr = (props) => {
  return (
    <StyledTr {...props} />
  )
}


export default Tr
